/**
 * Asset-source preview state (read-only).
 *
 * The assetSource cookie is owned entirely by the CloudFront function
 * asset-source-router-v2 (infrastructure repo): ?assetSource=pr-N redirects
 * with Set-Cookie, ?assetSource=production clears it, and every request with
 * the cookie is rewritten to the pr-N/ S3 prefix at the edge. The client only
 * ever READS the cookie — for the preview badge and analytics suppression.
 */

const COOKIE_NAME = 'assetSource'
const VALID_SOURCE = /^(pr-\d+|development)$/

export function getCurrentAssetSource(): string | null {
  const cookie = document.cookie
    .split('; ')
    .find((row) => row.startsWith(`${COOKIE_NAME}=`))

  const value = cookie?.split('=')[1]

  return value && VALID_SOURCE.test(value) ? value : null
}

export function isPreviewMode(): boolean {
  return getCurrentAssetSource() !== null
}
